import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { NgxPaginationModule } from 'ngx-pagination';
import { AffichagesModule, ERP_AFFICHAGES_API } from '@erp/affichages';
import { PagesModule } from 'app/main/pages/pages.module';
import { ErpAffichagesApiService } from './erp-affichages-api.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    NgxPaginationModule,
    NgSelectModule,
    Ng2FlatpickrModule,
    AffichagesModule,
    PagesModule
  ],
  exports: [AffichagesModule],
  providers: [
    ErpAffichagesApiService,
    { provide: ERP_AFFICHAGES_API, useExisting: ErpAffichagesApiService }
  ]
})
export class ErpAffichagesModule {}
